import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../services/api';

const ROLE_LABEL = { customer: 'Заказчик', supplier: 'Поставщик' };
const ROLE_COLOR = { customer: { bg: '#EFF6FF', color: '#1869DA' }, supplier: { bg: '#F0FDF4', color: '#16a34a' } };

const ProfilePage = ({ user }) => {
    const navigate = useNavigate();
    const [history, setHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(true);
    const [profile, setProfile] = useState(user);

    useEffect(() => {
        auth.getMe()
            .then(r => setProfile(r.data))
            .catch(() => {});

        auth.getHistory()
            .then(r => setHistory(r.data))
            .catch(() => {})
            .finally(() => setHistoryLoading(false));
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
    };

    const formatDate = (ds) => {
        if (!ds) return '—';
        return new Date(ds).toLocaleString('ru-RU', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const initials = (name) => {
        if (!name) return '?';
        return name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
    };

    const roleStyle = ROLE_COLOR[profile.company_type] || { bg: '#f3f4f6', color: '#6b7280' };

    return (
        <div className="lk-page">

            {/* ── Верхняя карточка ── */}
            <div className="lk-top-card">
                <div className="lk-avatar">{initials(profile.full_name)}</div>

                <div className="lk-identity">
                    <div className="lk-name">{profile.full_name || 'Пользователь'}</div>
                    <div className="lk-email">{profile.email}</div>
                    {profile.company_type && (
                        <span className="lk-role-badge" style={{ background: roleStyle.bg, color: roleStyle.color }}>
                            {ROLE_LABEL[profile.company_type] || profile.company_type}
                        </span>
                    )}
                </div>

                <button className="lk-logout-btn" onClick={handleLogout}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                        <polyline points="16 17 21 12 16 7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    Выйти
                </button>
            </div>

            {/* ── Инфо-карточки ── */}
            <div className="lk-info-grid">

                <div className="lk-info-card">
                    <div className="lk-info-card-title">Личные данные</div>
                    <div className="lk-info-rows">
                        <div className="lk-info-row">
                            <span className="lk-info-label">Имя</span>
                            <span className="lk-info-value">{profile.full_name || '—'}</span>
                        </div>
                        <div className="lk-info-row">
                            <span className="lk-info-label">Email</span>
                            <span className="lk-info-value">{profile.email || '—'}</span>
                        </div>
                        <div className="lk-info-row">
                            <span className="lk-info-label">Телефон</span>
                            <span className="lk-info-value">{profile.phone || '—'}</span>
                        </div>
                        <div className="lk-info-row">
                            <span className="lk-info-label">Дата регистрации</span>
                            <span className="lk-info-value">{formatDate(profile.created_at)}</span>
                        </div>
                    </div>
                </div>

                <div className="lk-info-card">
                    <div className="lk-info-card-title">Компания</div>
                    <div className="lk-info-rows">
                        <div className="lk-info-row">
                            <span className="lk-info-label">Название</span>
                            <span className="lk-info-value">{profile.company_name || '—'}</span>
                        </div>
                        <div className="lk-info-row">
                            <span className="lk-info-label">Тип</span>
                            <span className="lk-info-value">
                                {profile.company_type
                                    ? <span className="lk-role-badge" style={{ background: roleStyle.bg, color: roleStyle.color }}>
                                        {ROLE_LABEL[profile.company_type] || profile.company_type}
                                      </span>
                                    : '—'}
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            {/* ── История поиска ── */}
            <div className="lk-history-card">
                <div className="lk-history-header">
                    <div className="lk-info-card-title" style={{ marginBottom: 0 }}>История поиска</div>
                    {history.length > 0 && (
                        <span className="lk-history-count">{history.length} запросов</span>
                    )}
                </div>

                {historyLoading && (
                    <div className="loading"><div className="spinner" /></div>
                )}

                {!historyLoading && history.length === 0 && (
                    <div className="lk-history-empty">
                        <div style={{ fontSize: 36, marginBottom: 8 }}>🔍</div>
                        <div style={{ color: '#6b7280', fontSize: 14 }}>История поиска пуста</div>
                        <button className="lk-go-search-btn" onClick={() => navigate('/')}>
                            Перейти к поиску
                        </button>
                    </div>
                )}

                {!historyLoading && history.length > 0 && (
                    <div className="lk-history-list">
                        {history.map((item, idx) => (
                            <div key={item.id} className="lk-history-item">
                                <div className="lk-history-left">
                                    <span className="lk-history-type-badge" style={{
                                        background: item.search_type === 'ktru' ? '#EFF6FF' : '#F0FDF4',
                                        color: item.search_type === 'ktru' ? '#1869DA' : '#16a34a'
                                    }}>
                                        {item.search_type === 'ktru' ? 'КТРУ' : 'Модель'}
                                    </span>
                                    <span className="lk-history-query">{item.query}</span>
                                </div>
                                <div className="lk-history-right">
                                    {item.results_count != null && (
                                        <span className="lk-history-results">{item.results_count} результатов</span>
                                    )}
                                    <span className="lk-history-date">{formatDate(item.created_at)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

        </div>
    );
};

export default ProfilePage;
